import * as React from "react";
import { DataLayer, WebPage } from "@grandvisionhq/analytics";
import { TryInStoreProvider } from "@grandvisionhq/fun-try-in-store";
import { monetate } from "@grandvisionhq/svc-monetate";
import { mapMonetatePageType } from "../../utils/utils/map-monetate-page-type.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getPageSeo } from "../../utils/utils/get-page-seo.js";
import { useBloomreachPageName } from "../../hooks/hooks/use-bloomreach-page-name.js";
const CmsAnalytics = () => {
  const page = useBrPageContext();
  const pageSeo = getPageSeo(page);
  const casedPageName = useBloomreachPageName();
  const pageName = casedPageName?.toLowerCase();
  React.useEffect(() => {
    const seoPageType = pageSeo?.type;
    DataLayer.pushPageTypeToDataLayer(seoPageType, pageName);
    if (seoPageType && !pageName?.includes("checkout") && !pageName?.includes("product-detail-page")) {
      const monetatePageName = mapMonetatePageType(seoPageType);
      if (pageName === "homepage") {
        monetate().commitMonetateEvent("main");
      } else if (
        // These pages contain other monetate API calls which need to be called simultaneously, so the pages will commit the event themselves
        monetatePageName !== "category" && monetatePageName !== "product" && monetatePageName !== "cart"
      ) {
        monetate().commitMonetateEvent(monetatePageName);
      }
    }
  }, [pageName, pageSeo?.type]);
  return pageSeo ? /* @__PURE__ */ React.createElement(
    WebPage,
    {
      pageType: pageSeo.type,
      url: pageSeo.canonicalUrl,
      name: pageSeo.title,
      description: pageSeo.description
    }
  ) : null;
};
const CmsContainerPage = ({ children }) => {
  return /* @__PURE__ */ React.createElement(TryInStoreProvider, null, children, /* @__PURE__ */ React.createElement(CmsAnalytics, null));
};
export {
  CmsContainerPage,
  CmsContainerPage as default
};
//# sourceMappingURL=container.js.map
